import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

import { useProfile } from "../components/Hooks/UserHooks";
import { ModalSelectOffice } from "../components/modalSelectOffice";
import { useOffice } from "../hook/useOffice";

const AuthProtected = (props) => {
  const { userProfile, loading } = useProfile();
  const { isOpen, office } = useOffice();

  /*
    redirect is un-auth access protected routes via url
    */

  if (!userProfile && loading) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return (
    <>
      {!office && <ModalSelectOffice isOpen={isOpen} />}
      {props.children}
    </>
  );
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
